import React, { useState, useEffect, useRef, useContext } from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import { isNil } from "lodash";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import moment from "moment";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  DialogActions,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Switch,
  FormControlLabel,
  Grid,
  Divider,
  Tab,
  Tabs,
  Paper,
  Box,
  Typography,
} from "@material-ui/core";

import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import TabPanel from "../TabPanel";
import MessagesTab from "../ConnectionTabs/MessagesTab";
import NpsTab from "../ConnectionTabs/NpsTab";
import SchedulesTab from "../ConnectionTabs/SchedulesTab";
import FlowbuilderTab from "../ConnectionTabs/FlowbuilderTab";
import ChatbotTab from "../ConnectionTabs/ChatbotTab";
import IntegrationsTab from "../ConnectionTabs/IntegrationsTab";
import { Autorenew, FileCopy } from "@material-ui/icons";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import usePlans from "../../hooks/usePlans";
import { AuthContext } from "../../context/Auth/AuthContext";
import { Colorize } from "@material-ui/icons";
import ColorPicker from "../ColorPicker";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import getRandomHexColor from "../../utils/getRandomHexColor";
import { normalizeVacationFields } from "../../utils/vacationDateTime";
import { useChannelPlugins } from "../ChannelIcon";
import ChannelFieldRenderer from "../ChannelFieldRenderer";
import validateFieldSchema from "../../utils/validateFieldSchema";
import PluginBridge from "../PluginBridge";
import { connections as connectionsUI } from "@markedesk/plugin-sdk/ui";
import { cachedApi } from "../../services/cachedApi";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    gap: 4,
  },

  multFieldLine: {
    marginTop: 12,
    display: "flex",
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(1),
    },
  },

  btnWrapper: {
    position: "relative",
  },
  importMessage: {
    marginTop: 12,
    marginBottom: 12,
    paddingBottom: 20,
    paddingTop: 3,
    padding: 12,
    border: "solid grey 2px",
    borderRadius: 4,
    display: "flex",
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(1),
    },
  },

  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },

  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
  },
  tokenRefresh: {
    minWidth: "auto",
    display: "flex", // Torna o botão flexível para alinhar o conteúdo
    alignItems: "center", // Alinha verticalmente ao centro
    justifyContent: "center", // Alinha horizontalmente ao centro
  },
  colorAdorment: {
    width: 20,
    height: 20,
  },
  formControl: {
    width: 220,
    // paddingTop: 14
  },
  colorField: {
    width: 150,
  },
}));

const SessionSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
});

const WhatsAppModal = ({ open, onClose, whatsAppId, channel }) => {
  const classes = useStyles();
  const [autoToken, setAutoToken] = useState("");

  const inputFileRef = useRef(null);

  const [attachment, setAttachment] = useState(null);
  const [attachmentName, setAttachmentName] = useState("");

  const initialState = {
    name: "",
    greetingMessage: "",
    complationMessage: "",
    outOfHoursMessage: "",
    ratingMessage: "",
    isDefault: false,
    token: "",
    maxUseBotQueues: 3,
    provider: "beta",
    expiresTicket: 0,
    allowGroup: false,
    enableImportMessage: false,
    groupAsTicket: "disabled",
    timeUseBotQueues: "0",
    timeSendQueue: "0",
    sendIdQueue: 0,
    expiresTicketNPS: "0",
    expiresInactiveMessage: "",
    timeInactiveMessage: "",
    inactiveMessage: "",
    maxUseBotQueuesNPS: 3,
    whenExpiresTicket: 0,
    timeCreateNewTicket: 0,
    greetingMediaAttachment: "",
    importRecentMessages: "",
    importOldMessages: "",
    importOldMessagesGroups: "",
    collectiveVacationEnd: "",
    collectiveVacationStart: "",
    collectiveVacationMessage: "",
    // #4420 — limite de envios por conversa e anexo da mensagem de férias.
    maxUseCollectiveVacation: 1,
    collectiveVacationMediaPath: null,
    collectiveVacationMediaName: null,
    queueIdImportMessages: null,
    isOficial: false,
    phone_number_id: "",
    waba_id: "",
    send_token: "",
    business_id: "",
    phone_number: "",
    color: getRandomHexColor(),
    flowInactiveTime: 0,
    flowIdInactiveTime: 0,
    timeAwaitActiveFlowId: 0,
    maxUseInactiveTime: 1,
    timeToReturnQueue: 0,
    wavoip: "",
    enablePendingMessages: true,
  };
  const [whatsApp, setWhatsApp] = useState(initialState);
  const [selectedQueueIds, setSelectedQueueIds] = useState([]);
  const [queues, setQueues] = useState([]);
  const [tab, setTab] = useState("general");
  const [enableImportMessage, setEnableImportMessage] = useState(false);
  const [importOldMessagesGroups, setImportOldMessagesGroups] = useState(false);
  const [closedTicketsPostImported, setClosedTicketsPostImported] =
    useState(false);
  const [importOldMessages, setImportOldMessages] = useState(
    moment().add(-1, "days").format("YYYY-MM-DDTHH:mm")
  );
  const [importRecentMessages, setImportRecentMessages] = useState(
    moment().add(-1, "minutes").format("YYYY-MM-DDTHH:mm")
  );
  const [copied, setCopied] = useState(false);
  const [schedulesEnabled, setSchedulesEnabled] = useState(false);
  const [NPSEnabled, setNPSEnabled] = useState(false);
  const { user } = useContext(AuthContext);
  const [isOficial, setIsOficial] = useState(false);
  const channelPlugins = useChannelPlugins();
  const pluginMeta = channelPlugins.find(p => p.channel === channel);
  const isChannelPlugin = !!pluginMeta;

  // Nivel de topo quando e canal de plugin: "system" (abas nativas) | "plugin" (abas do plugin).
  const [topTab, setTopTab] = useState("system");

  // Abas custom do plugin (as nao-sistema declaradas no pluginMeta).
  const pluginCustomTabs = (pluginMeta?.tabs || []).filter((t) => !t.isSystem);

  // Sub-aba selecionada DENTRO do nivel "plugin".
  const [pluginTab, setPluginTab] = useState("");
  useEffect(() => {
    if (pluginCustomTabs.length && !pluginTab) {
      setPluginTab(pluginCustomTabs[0].name);
    }
  }, [pluginCustomTabs, pluginTab]);

  // Valor efetivo para os TabPanels do SISTEMA: quando estamos no nivel "plugin",
  // forca um valor que nao casa com nenhum panel (esconde as abas do sistema).
  const systemTabValue =
    isChannelPlugin && topTab !== "system" ? "__hidden__" : tab;
  const [channelData, setChannelData] = useState({});
  // Popula channelData com os defaultValue dos fields do plugin que ainda não
  // têm valor salvo — sem isto, um campo mostrado com defaultValue (só visual,
  // ver ChannelFieldRenderer) nunca é gravado se o usuário não editar na mão
  // (conexão nova, ou field novo adicionado ao plugin depois da conexão já
  // existir). Roda de novo sempre que pluginMeta.fields mudar (ex: plugin
  // recarregado com campos novos) — só preenche o que está ausente, nunca
  // sobrescreve valor já digitado/salvo.
  useEffect(() => {
    if (!pluginMeta?.fields?.length) return;
    setChannelData((prev) => {
      let changed = false;
      const next = { ...prev };
      for (const field of pluginMeta.fields) {
        if (field.defaultValue === undefined) continue;
        if (next[field.name] === undefined) {
          next[field.name] = field.defaultValue;
          changed = true;
        }
      }
      return changed ? next : prev;
    });
  }, [pluginMeta]);
  // Ao abrir para CRIAR (sem whatsAppId), zera o channelData — senão o modal
  // reaproveitava os campos da última conexão editada (ex: baseUrl/instanceKey
  // vazavam de uma conexão para a nova). Reinicia com os defaultValue do plugin.
  useEffect(() => {
    if (whatsAppId) return; // edição carrega o channelData salvo (outro effect)
    const defaults = {};
    for (const field of (pluginMeta?.fields || [])) {
      if (field.defaultValue !== undefined) defaults[field.name] = field.defaultValue;
    }
    setChannelData(defaults);
    setChannelDataErrors({});
  }, [whatsAppId, pluginMeta]);
  const [channelDataErrors, setChannelDataErrors] = useState({});
  const [useWhatsappOfficial, setUseWhatsappOfficial] = useState(false);
  const [colorPickerModalOpen, setColorPickerModalOpen] = useState(false);

  const [schedules, setSchedules] = useState([
    {
      weekday: i18n.t("queueModal.serviceHours.monday"),
      weekdayEn: "monday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: i18n.t("queueModal.serviceHours.tuesday"),
      weekdayEn: "tuesday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: i18n.t("queueModal.serviceHours.wednesday"),
      weekdayEn: "wednesday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: i18n.t("queueModal.serviceHours.thursday"),
      weekdayEn: "thursday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: i18n.t("queueModal.serviceHours.friday"),
      weekdayEn: "friday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: "Sábado",
      weekdayEn: "saturday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
    {
      weekday: "Domingo",
      weekdayEn: "sunday",
      startTimeA: "08:00",
      endTimeA: "12:00",
      startTimeB: "13:00",
      endTimeB: "18:00",
    },
  ]);

  const { get: getSetting } = useCompanySettings();
  const { getPlanCompany } = usePlans();



  const [webhooks, setWebhooks] = useState([]);
  const [flowIdNotPhrase, setFlowIdNotPhrase] = useState();
  const [flowIdWelcome, setFlowIdWelcome] = useState();
  const [flowIdInactiveTime, setFlowIdInactiveTime] = useState();
  const [timeAwaitActiveFlowId, setTimeAwaitActiveFlowId] = useState();
  const [showWavoipCall, setShowWavoipCall] = useState(false);

  useEffect(() => {
    if (!whatsAppId && !whatsApp.token) {
      setAutoToken(generateRandomCode(30));
    } else if (whatsAppId && !whatsApp.token) {
      setAutoToken(generateRandomCode(30));
    } else {
      setAutoToken(whatsApp.token);
    }
  }, [whatsAppId, whatsApp.token]);

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);
      setUseWhatsappOfficial(planConfigs.plan.useWhatsappOfficial);
      setShowWavoipCall(planConfigs.plan.wavoip);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/flowbuilder");
        setWebhooks(data.flows);
      } catch (err) {
        toastError(err);
      }
    })();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const settingSchedules = await getSetting({
        column: "scheduleType",
      });
      setSchedulesEnabled(settingSchedules.scheduleType === "connection");
      const settingNPS = await getSetting({
        column: "userRating",
      });
      setNPSEnabled(settingNPS.userRating === "enabled");
    };
    fetchData();
  }, []);

  const handleEnableImportMessage = async (e) => {
    setEnableImportMessage(e.target.checked);
  };

  const handleEnableIsOficial = async (e) => {
    setIsOficial(e.target.checked);
  };

  useEffect(() => {
    const fetchSession = async () => {
      if (!whatsAppId) return;

      try {
        const { data } = await api.get(`whatsapp/${whatsAppId}?session=0`);

        if (data && data?.flowIdNotPhrase) {
          const { data: flowDefault } = await api.get(
            `flowbuilder/${data.flowIdNotPhrase}`
          );
          const selectedFlowIdNotPhrase = flowDefault?.flow.id;
          setFlowIdNotPhrase(selectedFlowIdNotPhrase);
        }

        if (data && data?.flowIdWelcome) {
          const { data: flowDefault } = await api.get(
            `flowbuilder/${data.flowIdWelcome}`
          );
          const selectedFlowIdWelcome = flowDefault?.flow.id;
          setFlowIdWelcome(selectedFlowIdWelcome);
        }

        if (data && data?.flowIdInactiveTime) {
          const { data: flowDefault } = await api.get(
            `flowbuilder/${data.flowIdInactiveTime}`
          );
          const selectedFlowIdInactiveTime = flowDefault?.flow.id;
          setFlowIdInactiveTime(selectedFlowIdInactiveTime);
        }

        if (data && data?.timeAwaitActiveFlowId) {
          const { data: flowDefault } = await api.get(
            `flowbuilder/${data.timeAwaitActiveFlowId}`
          );
          const selectedTimeAwaitActiveFlowId = flowDefault?.flow.id;
          setTimeAwaitActiveFlowId(selectedTimeAwaitActiveFlowId);
        }

        // #4420 — datas de férias gravadas sem hora não aparecem num
        // datetime-local; normaliza ao carregar (utils/vacationDateTime).
        setWhatsApp(normalizeVacationFields(data));
        setAttachmentName(data.greetingMediaAttachment);
        setAutoToken(data.token);
        const whatsQueueIds = data.queues?.map((queue) => queue.id);
        setSelectedQueueIds(whatsQueueIds);
        setIsOficial(channel === "whatsapp_oficial");
        setSchedules(data.schedules);
        // Mescla com defaultValue dos fields do plugin — campos novos (não
        // existentes quando esta conexão foi criada) entram com o default em
        // vez de ficar ausentes até o usuário editar na mão (ver useEffect
        // de pluginMeta acima, mesma lógica pro caso de conexão NOVA).
        setChannelData((prev) => {
          const merged = { ...(data.channelData || {}) };
          for (const field of pluginMeta?.fields || []) {
            if (field.defaultValue !== undefined && merged[field.name] === undefined) {
              merged[field.name] = field.defaultValue;
            }
          }
          return merged;
        });

        if (!isNil(data?.importOldMessages)) {
          setEnableImportMessage(true);
          setImportOldMessages(data?.importOldMessages);
          setImportRecentMessages(data?.importRecentMessages);
          setClosedTicketsPostImported(data?.closedTicketsPostImported);
          setImportOldMessagesGroups(data?.importOldMessagesGroups);
        }
      } catch (err) {
        toastError(err);
      }
    };
    fetchSession();
  }, [whatsAppId]);

  useEffect(() => {
    (async () => {
      try {
        const data = await cachedApi.queues.findAll();
        setQueues(data);
      } catch (err) {
        toastError(err);
      }
    })();
  }, []);

  const handleChangeQueue = (e) => {
    setSelectedQueueIds(e);
  };

  const handleSaveWhatsApp = async (values) => {
    if (!whatsAppId) setAutoToken(generateRandomCode(30));

    if (NPSEnabled) {
      if (isNil(values.ratingMessage)) {
        toastError(i18n.t("whatsappModal.errorRatingMessage"));
        return;
      }

      if (
        values.expiresTicketNPS === "0" &&
        values.expiresTicketNPS === "" &&
        values.expiresTicketNPS === 0
      ) {
        toastError(i18n.t("whatsappModal.errorExpiresNPS"));
        return;
      }
    }

    if (values.timeSendQueue === "") values.timeSendQueue = "0";

    if (
      (values.sendIdQueue === 0 ||
        values.sendIdQueue === "" ||
        isNil(values.sendIdQueue)) &&
      values.timeSendQueue !== 0 &&
      values.timeSendQueue !== "0"
    ) {
      toastError(i18n.t("whatsappModal.errorSendQueue"));
      return;
    }

    const whatsappData = {
      ...values,
      flowIdWelcome: flowIdWelcome ? flowIdWelcome : null,
      flowIdInactiveTime: flowIdInactiveTime ? flowIdInactiveTime : null,
      flowIdNotPhrase: flowIdNotPhrase ? flowIdNotPhrase : null,
      timeAwaitActiveFlowId: timeAwaitActiveFlowId
        ? timeAwaitActiveFlowId
        : null,
      queueIds: selectedQueueIds,
      importOldMessages: enableImportMessage ? importOldMessages : null,
      importRecentMessages: enableImportMessage ? importRecentMessages : null,
      importOldMessagesGroups: importOldMessagesGroups
        ? importOldMessagesGroups
        : null,
      closedTicketsPostImported: closedTicketsPostImported
        ? closedTicketsPostImported
        : null,
      token: autoToken ? autoToken : null,
      schedules,
      channel,
      color: values.color ? values.color : getRandomHexColor(),
      wavoip: values.wavoip ? values.wavoip : null,
      // channelData carrega configs custom por conexão (ex: rejeitar chamadas)
      // tanto para canais de plugin quanto para o WhatsApp nativo do core.
      channelData,
    };

    // Validar campos do plugin
    if (isChannelPlugin && pluginMeta?.fields) {
      const { valid, errors } = await validateFieldSchema(pluginMeta.fields, channelData);
      if (!valid) {
        setChannelDataErrors(errors);
        toastError("Preencha os campos obrigatórios corretamente");
        return;
      }
      setChannelDataErrors({});
    }
    delete whatsappData["queues"];
    delete whatsappData["session"];

    try {
      if (whatsAppId) {
        if (
          whatsAppId &&
          enableImportMessage &&
          whatsApp?.status === "CONNECTED"
        ) {
          try {
            setWhatsApp({ ...whatsApp, status: "qrcode" });
            await api.delete(`/whatsappsession/${whatsApp.id}`);
          } catch (err) {
            toastError(err);
          }
        }

        await api.put(`/whatsapp/${whatsAppId}`, whatsappData);
        if (attachment != null) {
          const formData = new FormData();
          formData.append("file", attachment);
          await api.post(`/whatsapp/${whatsAppId}/media-upload`, formData);
        }
        if (!attachmentName && whatsApp.greetingMediaAttachment !== null) {
          await api.delete(`/whatsapp/${whatsAppId}/media-upload`);
        }
      } else {
        const { data } = await api.post("/whatsapp", whatsappData);
        if (attachment != null) {
          const formData = new FormData();
          formData.append("file", attachment);
          await api.post(`/whatsapp/${data.id}/media-upload`, formData);
        }
      }
      toast.success(i18n.t("whatsappModal.success"));

      handleClose();
    } catch (err) {
      toastError(err);
    }
  };

  function generateRandomCode(length) {
    const charset =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyvz0123456789";
    let code = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      code += charset.charAt(randomIndex);
    }
    return code;
  }

  const handleRefreshToken = () => {
    setAutoToken(generateRandomCode(30));
  };

  const handleChangeFlowIdNotPhrase = (e) => {
    console.log(e.target.value);
    setFlowIdNotPhrase(e.target.value);
  };

  const handleChangeFlowIdWelcome = (e) => {
    setFlowIdWelcome(e.target.value);
  };

  const handleChangeFlowIdInactiveTime = (e) => {
    setFlowIdInactiveTime(e.target.value);
  };

  const handleChangeTimeAwaitActiveFlowId = (e) => {
    setTimeAwaitActiveFlowId(e.target.value);
  };

  const handleCopyToken = () => {
    navigator.clipboard.writeText(autoToken); // Copia o token para a área de transferência
    setCopied(true); // Define o estado de cópia como verdadeiro
  };

  const handleSaveSchedules = async (values) => {
    toast.success("Clique em salvar para registar as alterações");
    setSchedules(values);
  };

  const handleClose = () => {
    onClose();
    setWhatsApp(initialState);
    setEnableImportMessage(false);
    // inputFileRef.current.value = null
    setAttachment(null);
    setAttachmentName("");
    setCopied(false);
  };

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const handleFileUpload = () => {
    const file = inputFileRef.current.files[0];
    setAttachment(file);
    setAttachmentName(file.name);
    inputFileRef.current.value = null;
  };

  const handleDeleFile = () => {
    setAttachment(null);
    setAttachmentName(null);
  };

  return (
    <div className={classes.root}>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
        scroll="paper"
      >
        <DialogTitle>
          {isChannelPlugin
            ? (whatsAppId
              ? `Editar ${pluginMeta.displayName}`
              : `Adicionar ${pluginMeta.displayName}`)
            : (whatsAppId
              ? i18n.t("whatsappModal.title.edit")
              : i18n.t("whatsappModal.title.add"))}
        </DialogTitle>
        <Formik
          initialValues={whatsApp}
          enableReinitialize={true}
          validationSchema={SessionSchema}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              handleSaveWhatsApp(values);
              actions.setSubmitting(false);
            }, 400);
          }}
        >
          {({ values, touched, errors, isSubmitting }) => (
            <Form>
              {/* Nivel de topo (so para canal de plugin): Sistema | Plugin */}
              {isChannelPlugin && (
                <Paper className={classes.mainPaper} elevation={1}>
                  <Tabs
                    value={topTab}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    onChange={(e, v) => setTopTab(v)}
                    className={classes.tab}
                  >
                    <Tab label="Sistema" value="system" />
                    <Tab label={pluginMeta.displayName || "Plugin"} value="plugin" />
                  </Tabs>
                </Paper>
              )}

              {/* Sub-barra: abas do SISTEMA (sempre para nativo; e quando topTab=system no plugin) */}
              {(!isChannelPlugin || topTab === "system") && (
                <Paper className={classes.mainPaper} elevation={1}>
                  <Tabs
                    value={tab}
                    indicatorColor="primary"
                    textColor="primary"
                    scrollButtons="on"
                    variant="scrollable"
                    onChange={handleTabChange}
                    className={classes.tab}
                  >
                    {[
                      <Tab key="general" label={i18n.t("whatsappModal.tabs.general")} value="general" />,
                      <Tab key="integrations" label={i18n.t("whatsappModal.tabs.queues")} value="integrations" />,
                      <Tab key="messages" label={i18n.t("whatsappModal.tabs.messages")} value="messages" />,
                      <Tab key="chatbot" label="Chatbot" value="chatbot" />,
                      <Tab key="nps" label={i18n.t("whatsappModal.tabs.assessments")} value="nps" />,
                      user.showFlow === "enabled" && (
                        <Tab key="flowbuilder" label="Fluxo Padrão" value="flowbuilder" />
                      ),
                      schedulesEnabled && (
                        <Tab key="schedules" label={i18n.t("whatsappModal.tabs.schedules")} value="schedules" />
                      ),
                    ]}
                  </Tabs>
                </Paper>
              )}

              {/* Sub-barra: abas do PLUGIN (quando topTab=plugin) */}
              {isChannelPlugin && topTab === "plugin" && pluginCustomTabs.length > 0 && (
                <Paper className={classes.mainPaper} elevation={1}>
                  <Tabs
                    value={pluginTab}
                    indicatorColor="primary"
                    textColor="primary"
                    scrollButtons="on"
                    variant="scrollable"
                    onChange={(e, v) => setPluginTab(v)}
                    className={classes.tab}
                  >
                    {[...pluginCustomTabs]
                      .sort((a, b) => (a.order ?? 99) - (b.order ?? 99))
                      .map((t) => (
                        <Tab key={t.name} label={t.label} value={t.name} />
                      ))}
                  </Tabs>
                </Paper>
              )}
              <Paper className={classes.paper} elevation={0}>
                <TabPanel
                  className={classes.container}
                  value={systemTabValue}
                  name={"general"}
                >
                  <DialogContent dividers>
                    {(
                    <>
                    {attachmentName && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row-reverse",
                        }}
                      >
                        <Button
                          variant="outlined"
                          color="primary"
                          endIcon={<DeleteOutlineIcon />}
                          onClick={handleDeleFile}
                        >
                          {attachmentName}
                        </Button>
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column-reverse",
                      }}
                    >
                      <input
                        type="file"
                        accept="video/*,image/*"
                        ref={inputFileRef}
                        style={{ display: "none" }}
                        onChange={handleFileUpload}
                      />
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => inputFileRef.current.click()}
                      >
                        {i18n.t("userModal.buttons.addImage")}
                      </Button>
                    </div>
                    {/* NOME E PADRAO */}
                    <div className={classes.multFieldLine}>
                      <Grid spacing={2} container>
                        <Grid item>
                          <Field
                            as={TextField}
                            label={i18n.t("whatsappModal.form.name")}
                            autoFocus
                            name="name"
                            error={touched.name && Boolean(errors.name)}
                            helperText={touched.name && errors.name}
                            variant="outlined"
                            margin="dense"
                            className={classes.textField}
                          />
                        </Grid>

                        {/* COR */}
                        <Grid item>
                          <Field
                            as={TextField}
                            label={i18n.t("connections.table.color")}
                            name="color"
                            id="color"
                            onFocus={() => {
                              setColorPickerModalOpen(false);
                            }}
                            error={touched.color && Boolean(errors.color)}
                            helperText={touched.color && errors.color}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <div
                                    style={{ backgroundColor: values.color }}
                                    className={classes.colorAdorment}
                                  ></div>
                                </InputAdornment>
                              ),
                              endAdornment: (
                                <IconButton
                                  size="small"
                                  color="default"
                                  onClick={() => setColorPickerModalOpen(true)}
                                >
                                  <Colorize />
                                </IconButton>
                              ),
                            }}
                            variant="outlined"
                            margin="dense"
                            className={classes.colorField}
                          />
                          <ColorPicker
                            open={colorPickerModalOpen}
                            handleClose={() => setColorPickerModalOpen(false)}
                            onChange={(color) => {
                              values.color = color;
                              setWhatsApp(() => {
                                return { ...values, color };
                              });
                            }}
                          />
                        </Grid>

                        <Grid style={{ paddingTop: 15 }} item>
                          <FormControlLabel
                            control={
                              <Field
                                as={Switch}
                                color="primary"
                                name="isDefault"
                                checked={values.isDefault}
                              />
                            }
                            label={i18n.t("whatsappModal.form.default")}
                          />
                          {useWhatsappOfficial &&
                            channel === "whatsapp_oficial" && (
                              <FormControlLabel
                                style={{ marginRight: 7, color: "gray" }}
                                label={i18n.t("whatsappModal.form.isOficial")}
                                labelPlacement="end"
                                control={
                                  <Switch
                                    size="medium"
                                    checked={isOficial}
                                    onChange={handleEnableIsOficial}
                                    name="isOficial"
                                    color="primary"
                                  />
                                }
                              />
                            )}
                          <FormControlLabel
                            control={
                              <Field
                                as={Switch}
                                color="primary"
                                name="allowGroup"
                                checked={values.allowGroup}
                              />
                            }
                            label={i18n.t("whatsappModal.form.group")}
                          />
                          <FormControlLabel
                            control={
                              <Field
                                as={Switch}
                                color="primary"
                                name="enablePendingMessages"
                                checked={values.enablePendingMessages}
                              />
                            }
                            label={i18n.t("whatsappModal.form.enablePendingMessages")}
                          />
                          {!isChannelPlugin && (
                            <>
                              <FormControlLabel
                                control={
                                  <Switch
                                    color="primary"
                                    checked={channelData?.sendCallMessage === true}
                                    onChange={(e) => {
                                      const checked = e.target.checked;
                                      setChannelData((prev) => ({
                                        ...prev,
                                        sendCallMessage: checked,
                                      }));
                                    }}
                                  />
                                }
                                label={i18n.t("whatsappModal.form.sendCallMessage")}
                              />
                              <FormControlLabel
                                control={
                                  <Switch
                                    color="primary"
                                    checked={channelData?.rejectCalls === true}
                                    onChange={(e) => {
                                      const checked = e.target.checked;
                                      setChannelData((prev) => ({
                                        ...prev,
                                        rejectCalls: checked,
                                      }));
                                    }}
                                  />
                                }
                                label={i18n.t("whatsappModal.form.rejectCalls")}
                              />
                            </>
                          )}
                        </Grid>
                        {!isChannelPlugin && channelData?.sendCallMessage && (
                          <Grid xs={12} item>
                            <TextField
                              label={i18n.t("whatsappModal.form.rejectCallsMessage")}
                              fullWidth
                              multiline
                              minRows={2}
                              variant="outlined"
                              margin="dense"
                              value={channelData?.callRejectMessage || ""}
                              onChange={(e) => {
                                const value = e.target.value;
                                setChannelData((prev) => ({
                                  ...prev,
                                  callRejectMessage: value,
                                }));
                              }}
                              helperText={i18n.t("whatsappModal.form.rejectCallsMessageHelp")}
                            />
                          </Grid>
                        )}
                        <Grid xs={6} md={4} item>
                          <FormControl
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            className={classes.formControl}
                          >
                            <InputLabel id="groupAsTicket-selection-label">
                              {i18n.t("whatsappModal.form.groupAsTicket")}
                            </InputLabel>
                            <Field
                              as={Select}
                              label={i18n.t("whatsappModal.form.groupAsTicket")}
                              placeholder={i18n.t(
                                "whatsappModal.form.groupAsTicket"
                              )}
                              labelId="groupAsTicket-selection-label"
                              id="groupAsTicket"
                              name="groupAsTicket"
                            >
                              <MenuItem value={"disabled"}>
                                {i18n.t("whatsappModal.menuItem.disabled")}
                              </MenuItem>
                              <MenuItem value={"enabled"}>
                                {i18n.t("whatsappModal.menuItem.enabled")}
                              </MenuItem>
                            </Field>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </div>

                    {isOficial && (
                      <div className={classes.importMessage}>
                        <Grid style={{ marginTop: 18 }} container spacing={1}>
                          <Grid xs={12} md={6} xl={3} item>
                            <Field
                              fullWidth
                              as={TextField}
                              label={i18n.t(
                                "whatsappModal.form.phone_number_id"
                              )}
                              name="phone_number_id"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              error={
                                touched.phone_number_id &&
                                Boolean(errors.phone_number_id)
                              }
                              helperText={
                                touched.phone_number_id &&
                                errors.phone_number_id
                              }
                              variant="outlined"
                              required={isOficial}
                            />
                          </Grid>
                          <Grid xs={12} md={6} xl={3} item>
                            <Field
                              fullWidth
                              as={TextField}
                              label={i18n.t("whatsappModal.form.waba_id")}
                              name="waba_id"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              error={touched.waba_id && Boolean(errors.waba_id)}
                              helperText={touched.waba_id && errors.waba_id}
                              variant="outlined"
                              required={isOficial}
                            />
                          </Grid>

                          <Grid xs={12} md={6} xl={3} item>
                            <Field
                              fullWidth
                              as={TextField}
                              label={i18n.t("whatsappModal.form.business_id")}
                              name="business_id"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              error={
                                touched.business_id &&
                                Boolean(errors.business_id)
                              }
                              helperText={
                                touched.business_id && errors.business_id
                              }
                              variant="outlined"
                              required={isOficial}
                            />
                          </Grid>
                          <Grid xs={12} md={6} xl={3} item>
                            <Field
                              fullWidth
                              as={TextField}
                              label={i18n.t("whatsappModal.form.phone_number")}
                              name="phone_number"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              error={
                                touched.phone_number &&
                                Boolean(errors.phone_number)
                              }
                              helperText={
                                touched.phone_number && errors.phone_number
                              }
                              variant="outlined"
                              required={isOficial}
                            />
                          </Grid>
                          <Grid xs={12} md={12} xl={12} item>
                            <Field
                              fullWidth
                              as={TextField}
                              label={i18n.t("whatsappModal.form.send_token")}
                              name="send_token"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              error={
                                touched.send_token && Boolean(errors.send_token)
                              }
                              helperText={
                                touched.send_token && errors.send_token
                              }
                              variant="outlined"
                              required={isOficial}
                            />
                          </Grid>
                        </Grid>
                      </div>
                    )}
                    {!isOficial && (
                      <div className={classes.importMessage}>
                        <Grid container spacing={1} alignItems="center">
                          <Grid item xs={12} sm="auto">
                            <FormControlLabel
                              style={{ marginRight: 7, color: "gray" }}
                              label={i18n.t(
                                "whatsappModal.form.importOldMessagesEnable"
                              )}
                              labelPlacement="end"
                              control={
                                <Switch
                                  size="small"
                                  checked={enableImportMessage}
                                  onChange={handleEnableImportMessage}
                                  name="importOldMessagesEnable"
                                  color="primary"
                                />
                              }
                            />
                          </Grid>
                          {enableImportMessage && (
                            <>
                              <Grid item xs={12} sm="auto">
                                <FormControlLabel
                                  style={{ marginRight: 7, color: "gray" }}
                                  label={i18n.t(
                                    "whatsappModal.form.importOldMessagesGroups"
                                  )}
                                  labelPlacement="end"
                                  control={
                                    <Switch
                                      size="small"
                                      checked={importOldMessagesGroups}
                                      onChange={(e) =>
                                        setImportOldMessagesGroups(
                                          e.target.checked
                                        )
                                      }
                                      name="importOldMessagesGroups"
                                      color="primary"
                                    />
                                  }
                                />
                              </Grid>
                              <Grid item xs={12} sm="auto">
                                <FormControlLabel
                                  style={{ marginRight: 7, color: "gray" }}
                                  label={i18n.t(
                                    "whatsappModal.form.closedTicketsPostImported"
                                  )}
                                  labelPlacement="end"
                                  control={
                                    <Switch
                                      size="small"
                                      checked={closedTicketsPostImported}
                                      onChange={(e) =>
                                        setClosedTicketsPostImported(
                                          e.target.checked
                                        )
                                      }
                                      name="closedTicketsPostImported"
                                      color="primary"
                                    />
                                  }
                                />
                              </Grid>
                            </>
                          )}
                          <Grid item xs={12}>
                            <Typography
                              variant="caption"
                              style={{ color: "#999", fontSize: "0.7rem" }}
                            >
                              {i18n.t("whatsappModal.form.importOldMessagesDescription")}
                            </Typography>
                          </Grid>
                          {enableImportMessage && (
                            <Grid item xs={12}>
                              <FormControl
                                variant="outlined"
                                margin="dense"
                                className={classes.FormControl}
                                fullWidth
                              >
                                <InputLabel id="queueIdImportMessages-selection-label">
                                  {i18n.t(
                                    "whatsappModal.form.queueIdImportMessages"
                                  )}
                                </InputLabel>
                                <Field
                                  as={Select}
                                  name="queueIdImportMessages"
                                  id="queueIdImportMessages"
                                  value={values.queueIdImportMessages || "0"}
                                  required={enableImportMessage}
                                  label={i18n.t(
                                    "whatsappModal.form.queueIdImportMessages"
                                  )}
                                  placeholder={i18n.t(
                                    "whatsappModal.form.queueIdImportMessages"
                                  )}
                                  labelId="queueIdImportMessages-selection-label"
                                >
                                  <MenuItem value={0}>&nbsp;</MenuItem>
                                  {queues.map((queue) => (
                                    <MenuItem key={queue.id} value={queue.id}>
                                      {queue.name}
                                    </MenuItem>
                                  ))}
                                </Field>
                              </FormControl>
                            </Grid>
                          )}
                        </Grid>
                      </div>
                    )}
                    {enableImportMessage && (
                      <span style={{ color: "red" }}>
                        {i18n.t("whatsappModal.form.importAlert")}
                      </span>
                    )}

                    {/* TOKEN */}
                    <Box display="flex" alignItems="center">
                      <Grid xs={6} md={12} item>
                        <Field
                          as={TextField}
                          label={i18n.t("whatsappModal.form.token")}
                          type="token"
                          fullWidth
                          // name="token"
                          value={autoToken}
                          variant="outlined"
                          margin="dense"
                          disabled
                        />
                      </Grid>
                      <Button
                        onClick={handleRefreshToken}
                        disabled={isSubmitting}
                        className={classes.tokenRefresh}
                        variant="text"
                        startIcon={
                          <Autorenew
                            style={{ marginLeft: 5, color: "green" }}
                          />
                        }
                      />
                      <Button
                        onClick={handleCopyToken}
                        className={classes.tokenRefresh}
                        variant="text"
                        startIcon={
                          <FileCopy
                            style={{ color: copied ? "blue" : "inherit" }}
                          />
                        }
                      />
                    </Box>

                    <div>
                      <h3>{i18n.t("whatsappModal.form.queueRedirection")}</h3>
                      <p>{i18n.t("whatsappModal.form.queueRedirectionDesc")}</p>
                      <Grid spacing={2} container>
                        <Grid xs={6} md={6} item>
                          <FormControl
                            variant="outlined"
                            margin="dense"
                            className={classes.FormControl}
                            fullWidth
                          >
                            <InputLabel id="sendIdQueue-selection-label">
                              {i18n.t("whatsappModal.form.sendIdQueue")}
                            </InputLabel>
                            <Field
                              as={Select}
                              name="sendIdQueue"
                              id="sendIdQueue"
                              value={values.sendIdQueue || "0"}
                              required={values.timeSendQueue > 0}
                              label={i18n.t("whatsappModal.form.sendIdQueue")}
                              placeholder={i18n.t(
                                "whatsappModal.form.sendIdQueue"
                              )}
                              labelId="sendIdQueue-selection-label"
                            >
                              <MenuItem value={0}>&nbsp;</MenuItem>
                              {queues.map((queue) => (
                                <MenuItem key={queue.id} value={queue.id}>
                                  {queue.name}
                                </MenuItem>
                              ))}
                            </Field>
                          </FormControl>
                        </Grid>

                        <Grid xs={6} md={6} item>
                          <Field
                            as={TextField}
                            label={i18n.t("whatsappModal.form.timeSendQueue")}
                            fullWidth
                            name="timeSendQueue"
                            variant="outlined"
                            margin="dense"
                            error={
                              touched.timeSendQueue &&
                              Boolean(errors.timeSendQueue)
                            }
                            helperText={
                              touched.timeSendQueue && errors.timeSendQueue
                            }
                          />
                        </Grid>
                      </Grid>
                    </div>
                    </>
                    )}
                  </DialogContent>
                </TabPanel>
                <IntegrationsTab
                  tab={systemTabValue}
                  classes={classes}
                  selectedQueueIds={selectedQueueIds}
                  handleChangeQueue={handleChangeQueue}
                  showWavoipCall={showWavoipCall}
                />
                <MessagesTab tab={systemTabValue} classes={classes} whatsAppId={whatsAppId} />

                <ChatbotTab
                  tab={systemTabValue}
                  classes={classes}
                  webhooks={webhooks}
                  flowIdInactiveTime={flowIdInactiveTime}
                  handleChangeFlowIdInactiveTime={handleChangeFlowIdInactiveTime}
                />

                <NpsTab tab={systemTabValue} classes={classes} />

                {/* Flowbuilder */}
                {user.showFlow === "enabled" && (
                  <FlowbuilderTab
                    tab={systemTabValue}
                    classes={classes}
                    webhooks={webhooks}
                    flowIdNotPhrase={flowIdNotPhrase}
                    handleChangeFlowIdNotPhrase={handleChangeFlowIdNotPhrase}
                    flowIdWelcome={flowIdWelcome}
                    handleChangeFlowIdWelcome={handleChangeFlowIdWelcome}
                  />
                )}

                {/* Schedules */}
                <SchedulesTab
                  tab={systemTabValue}
                  classes={classes}
                  schedules={schedules}
                  handleSaveSchedules={handleSaveSchedules}
                />

                {/* Sub-abas do PLUGIN (nivel topTab="plugin") — campos isolados do sistema */}
                {isChannelPlugin && topTab === "plugin" && pluginCustomTabs.map((ct) => (
                  <TabPanel key={ct.name} value={pluginTab} name={ct.name}>
                    <DialogContent dividers>
                      {/* Preview ao vivo (opcional) — só plugins que registram um
                          controller para este slot renderizam algo aqui; sem
                          controller, custo ~zero (ver usePluginSlot). channelData
                          reflete o que está DIGITADO agora, antes de salvar. */}
                      <PluginBridge
                        slot={connectionsUI.slots.FORM_PREVIEW}
                        actions={false}
                        layout="flex"
                        context={{ whatsappId: whatsAppId, channel, channelData }}
                      >
                        <></>
                      </PluginBridge>
                      {pluginMeta.fields
                        .filter((f) => f.tab === ct.name)
                        .map((field) => {
                          // Campo do model (allowGroup) usa Formik Field
                          if (field.name === "allowGroup") {
                            return (
                              <FormControlLabel
                                key={field.name}
                                style={{ marginTop: 8 }}
                                control={
                                  <Field
                                    as={Switch}
                                    color="primary"
                                    name="allowGroup"
                                    checked={values.allowGroup}
                                  />
                                }
                                label={field.label}
                              />
                            );
                          }
                          // Página HTML servida pelo plugin (iframe)
                          if (field.type === "htmlPage") {
                            const backendUrl = process.env.REACT_APP_BACKEND_URL || "";
                            const ep = (field.endpoint || "").startsWith("/") ? field.endpoint : `/${field.endpoint || ""}`;
                            if (!whatsAppId) {
                              return (
                                <Typography key={field.name} color="textSecondary" style={{ padding: 16 }}>
                                  Salve e conecte a conexão para gerenciar {field.label}.
                                </Typography>
                              );
                            }
                            if (!pluginMeta.routePath) {
                              return (
                                <Typography key={field.name} color="textSecondary" style={{ padding: 16 }}>
                                  {field.label} indisponível — conecte a conexão primeiro.
                                </Typography>
                              );
                            }
                            const src = `${backendUrl}${pluginMeta.routePath}${ep}?connectionId=${whatsAppId}`;
                            return (
                              <div key={field.name} style={{ width: "100%", height: field.height || 700, border: "1px solid #e0e0e0", borderRadius: 4, overflow: "hidden" }}>
                                <iframe
                                  title={field.label || "Plugin"}
                                  src={src}
                                  style={{ width: "100%", height: "100%", border: 0, display: "block" }}
                                />
                              </div>
                            );
                          }
                          // Campos customizados → channelData
                          return (
                            <ChannelFieldRenderer
                              key={field.name}
                              field={field}
                              value={channelData[field.name]}
                              onChange={(name, val) => setChannelData((prev) => ({ ...prev, [name]: val }))}
                              error={channelDataErrors[field.name]}
                            />
                          );
                        })}
                    </DialogContent>
                  </TabPanel>
                ))}
              </Paper>
              <DialogActions>
                <Button
                  onClick={handleClose}
                  color="secondary"
                  disabled={isSubmitting}
                  variant="outlined"
                >
                  {i18n.t("whatsappModal.buttons.cancel")}
                </Button>
                <Button
                  type="submit"
                  color="primary"
                  disabled={isSubmitting}
                  variant="contained"
                  className={classes.btnWrapper}
                >
                  {whatsAppId
                    ? i18n.t("whatsappModal.buttons.okEdit")
                    : i18n.t("whatsappModal.buttons.okAdd")}
                  {isSubmitting && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </div >
  );
};

export default React.memo(WhatsAppModal);
